import type { CrmStage } from '@/entities/crm-entry';

// Fonte unica de verdade para a paleta dos estagios do CRM.
// Padrao Notion Kanban: card com background pastel (-50, super sutil) +
// borda da mesma familia em -100 (quase imperceptivel) + dot saturado
// (-500) no header da coluna.
// Texto do card permanece gray-900/700/500 (contraste WCAG AA ok sobre
// todos os tons -50).
export type StageColorConfig = {
  dot: string;
  bg: string;
  bgHover: string;
  border: string;
  label: string;
};

export const STAGE_COLORS: Record<CrmStage, StageColorConfig> = {
  LEAD: {
    dot: 'bg-gray-400',
    bg: 'bg-gray-50',
    bgHover: 'hover:bg-gray-100',
    border: 'border-gray-200',
    label: 'Lead',
  },
  EM_CONVERSA: {
    dot: 'bg-blue-500',
    bg: 'bg-blue-50',
    bgHover: 'hover:bg-blue-100',
    border: 'border-blue-100',
    label: 'Em conversa',
  },
  PROPOSTA: {
    dot: 'bg-amber-500',
    bg: 'bg-amber-50',
    bgHover: 'hover:bg-amber-100',
    border: 'border-amber-100',
    label: 'Proposta',
  },
  FECHADO: {
    dot: 'bg-emerald-500',
    bg: 'bg-emerald-50',
    bgHover: 'hover:bg-emerald-100',
    border: 'border-emerald-100',
    label: 'Fechado',
  },
};
